import { Link } from 'react-router-dom';
import LuckyDraw from '@/components/feature/LuckyDraw';
import SectionHeading from '@/components/feature/SectionHeading';

export default function DrawSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          align="left"
          eyebrow="抽奖玩法演示"
          tone="primary"
          title="转盘到底是怎么转的？先在这里试一次"
          desc="抽奖过程完全随机，每次抽取相互独立。下面是一个玩法演示，帮你直观理解奖池、层级与开奖方式。"
        />
        <Link
          to="/rules#lucky"
          className="self-start md:self-auto shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-50 border border-background-200 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <i className="ri-file-list-3-line"></i>
          查看概率说明
        </Link>
      </div>

      <div className="mt-10">
        <LuckyDraw />
      </div>
    </section>
  );
}